module.exports = __webpack_public_path__ + "img/Group 12567@2x.19d6bc68.png";